<template>
    <div>
        <v-container fluid>
            <v-row class="p-3">
                <v-col
                        v-for="(image,index) in img"
                        :key="image.id"
                        cols="12"
                        :class="isMobile?'mx-auto my-2 card boxStyle' : 'mx-3 my-2 card boxStyle' "
                        md="2"
                        :data-img="image.id"
                >
                    <v-radio-group class="p-0 m-0" v-model="selectedImage">
                        <v-radio
                                color="indigo"
                                :value="image.value"
                        ></v-radio>
                    </v-radio-group>
                    <img :src="image.full_path"  class="img-fluid"
                         :key="image.id">
                    <p class="text-center my-0">{{image.name}}</p>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
import Swal from "sweetalert2";

export default {
    name: "logoShape",
    data() {
        return {
            selectedImage: [],
            img: [
                {
                    id: '1',
                    name: 'مربع',
                    value: 'circle',
                    full_path: require('../../../../public/media/site/logoShape/مربع-1.png')
                },
                {
                    id: '2',
                    name: 'دایره',
                    value: 'square',
                    full_path: require('../../../../public/media/site/logoShape/دایره1.png')
                },
                {
                    id: '3',
                    name: 'بیضی',
                    value: 'oval',
                    full_path: require('../../../../public/media/site/logoShape/بیضی2.png')
                },
                {
                    id: '4',
                    name: 'لوزی',
                    value: 'rhombus',
                    full_path: require('../../../../public/media/site/logoShape/لوزی2.png')
                },
                {
                    id: '5',
                    name: 'مثلث',
                    value: 'triangle',
                    full_path: require('../../../../public/media/site/logoShape/مثلث2.png')
                },
                {
                    id: '6',
                    name: 'مربع وشش ضلعی',
                    value: 'other',
                    full_path: require('../../../../public/media/site/logoShape/مربع-وشش-ضلعی2.png')
                },
                {
                    id: '7',
                    name: 'مستطیل',
                    value: 'rectangle',
                    full_path: require('../../../../public/media/site/logoShape/مستطیل1.png')
                },
            ],
            count: 1,
        }
    },
    watch:{
        selectedImage() {
            this.$emit('persianName',this.img.find((x)=>x.value === this.selectedImage).name,"logoShape")
            this.$emit('input', this.selectedImage)
        }
    }
}
</script>

<style scoped>

</style>